import { rem } from 'polished';
import styled, { css } from 'styled-components';

export const VisuallyHiddenStyles = css`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const VisuallyHiddenFocusable = css`
  &:active,
  &:focus {
    clip: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    position: static;
    width: auto;
  }
`;

export const ClearfixStyles = css`
  &:before,
  &:after {
    content: ' ';
    display: table;
  }
  &:after {
    clear: both;
  }
`;

export const SearchPadding = css`
  padding-left: ${rem(12)};
  padding-right: ${rem(12)};
`;

export const Clearfix = styled.div`
  ${ClearfixStyles};
`;
